import template from './ecocode-trustpilot-business-unit-config.html.twig';

const {Component, State} = Shopware;
const {object} = Shopware.Utils;

Component.register('ecocode-trustpilot-business-unit-config', {
    template,
    emits: ['update:value'],
    inheritAttrs: false,
    inject: ['ecocodeTrustpilotConfigurationService', 'repositoryFactory'],
    props: {
        value: {
            type: Object,
            default() {
                return {
                    businessUnit: null,
                    templates: {},
                    productTemplates: {},
                    useCustomTemplates: false
                };
            }
        }
    },
    data() {
        return {
            businessUnitsList: [],
            templatesList: {},
            productTemplatesList: {},
            activeLanguages: [],
            currentValue: {
                businessUnit: null,
                templates: {},
                productTemplates: {},
                useCustomTemplates: false
            }
        };
    },

    computed: {
        businessUnitOptions() {
            if (!this.businessUnitsList || !this.currentValue) {
                return [];
            }

            const options = [];

            this.businessUnitsList.forEach((businessUnit) => {
                if (!this.currentValue.businessUnit) {
                    this.currentValue.businessUnit = businessUnit.id;
                    this.triggerChange()
                }

                let label = `${businessUnit.displayName}`;
                if (businessUnit.companyName) {
                    label = `${businessUnit.displayName} (${businessUnit.companyName} )`;
                }

                options.push({
                    label,
                    value: businessUnit.id
                });
            });

            return options;
        },
        productInvitationState() {
            return State.getters.sendProductInvitation;
        }
    },
    async mounted() {
        this.isLoading = true;

        const configuration = await this.loadConfiguration();

        this.activeLanguages = await this.getActiveLanguages();
        this.prepareTemplatesLocaleList()

        this.businessUnitsList = configuration.businessUnits;
        this.isLoading = false;

        if (this.value) {
            this.currentValue = {
                ...this.currentValue,
                ...object.deepCopyObject(this.value)
            }
        }
    },
    methods: {
        async getActiveLanguages() {
            const languageRepository = this.repositoryFactory.create('language');
            const criteria = new Shopware.Data.Criteria();

            criteria.addFilter(
                Shopware.Data.Criteria.equals('active', true)
            );
            criteria.addSorting(
                Shopware.Data.Criteria.sort('name', 'ASC')
            );
            criteria.addAssociation('locale');

            const result = await languageRepository.search(criteria, Shopware.Context.api);

            return result.map(lang => ({
                id: lang.id,
                name: lang.name,
                isoCode: lang.locale?.code || null
            }));
        },
        async loadConfiguration() {
            const configuration = await this.ecocodeTrustpilotConfigurationService.getBusinessUnitConfiguration();

            if (configuration.status === 'not_connected') {
                this.$router.replace({name: 'ecocode.trustpilot.setup.connect'});
            }

            if (configuration.status === 'invalid_token') {
                this.$router.replace({name: 'ecocode.trustpilot.setup.connect'});
            }

            return configuration;
        },
        prepareTemplatesLocaleList() {
            this.activeLanguages.forEach((lang) => {
                if (!this.templatesList.hasOwnProperty(lang.isoCode)) {
                    this.templatesList[lang.isoCode] = '';
                }
                if (!this.productTemplatesList.hasOwnProperty(lang.isoCode)) {
                    this.productTemplatesList[lang.isoCode] = '';
                }
            });
        },
        getDefaultTemplates() {
            const templates = {};
            this.activeLanguages.forEach((lang) => {
                templates[lang.isoCode] = null;
            });
            return templates;
        },
        triggerChange() {
            if (this.currentValue.useCustomTemplates === false) {
                this.currentValue.templates = this.getDefaultTemplates();
                this.currentValue.productTemplates = this.getDefaultTemplates();
            }

            // wait for next render on root value change.
            this.$nextTick(() => {
                this.$emit('update:value', object.deepCopyObject(this.currentValue));
            })
        }
    }
});
